module.exports = __webpack_public_path__ + "img/collection-diamondJewelrySignature.ce6a8d4.webp";